const ddadosVisualizarAlvara = {
  Titulo: "Visualizar Alvará",
  Campos: {
    Id: {
      Tipo: "number",
      Label: "Id",
      Desabilitado: true
    },
    IdObraProjeto: {
      Tipo: "number",
      Label: "Id Obra Projeto",
      Desabilitado: true
    },
    Protocolo: {
      Tipo: "text",
      Label: "Protocolo",
      Desabilitado: true
    },
    Processo: {
      Tipo: "text",
      Label: "Processo",
      Desabilitado: true
    },
    Projeto: {
      Tipo: "text",
      Label: "Projeto",
      Desabilitado: true
    },
    DataInicio: {
      Tipo: "date",
      Label: "Data de Início da Obra",
      Desabilitado: true
    },
    Solicitante: {
      Tipo: "text",
      Label: "Solicitante",
      Desabilitado: true
    },
    ResponsavelProjeto: {
      Tipo: "text",
      Label: "Profissional Responsável pelo Projeto",
      Desabilitado: true
    },
    ARTResponsavelProjeto: {
      Tipo: "text",
      Label: "ART",
      Desabilitado: true
    },
    ResponsavelExecucao: {
      Tipo: "text",
      Label: "Profissional Responsável pela Execução",
      Desabilitado: true
    },
    ARTResponsavelExecucao: {
      Tipo: "text",
      Label: "ART",
      Desabilitado: true
    },
    DataVencimento: {
      Tipo: "date",
      Label: "Alvará Válido Até",
      Desabilitado: true
    },
    Numero: {
      Tipo: "text",
      Label: "Número do Alvará",
      Desabilitado: true
    },
    Situacao: {
      Tipo: "number",
      Label: "Situação do Alvará",
      Desabilitado: true
    },
    Proprietario: {
      Tipo: "text",
      Label: "Proprietário",
      Desabilitado: true
    }
  }
};

export { ddadosVisualizarAlvara };
